import React from 'react';
import PracticesList from './PracticesList/PracticesList';

const PracticeManagement = () => {
  return (
    <div className="container-fluid">
      <PracticesList />
    </div>
  );
};

export default PracticeManagement;
